exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1 {\n  margin: 20px 0; }\n\n.photo-container {\n  width: 640px;\n  height: 480px;\n  border: 1px solid gray; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/dominik/Documents/projekty/guru-monarch-beach-resort/guru-monarch-beach-resort/src/app/gallery/photo-detail/photo-detail.component.scss
// module id = ../../../../../src/app/gallery/photo-detail/photo-detail.component.scss
// module chunks = main